function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.7,
  cx: 21,
  cy: 21,
  r: 20,
  fill: "#fff"
});
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 21,
  r: 20,
  stroke: "#333",
  strokeWidth: 1.5
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.15 24.886L10.946 31l6.112-.257-.019-1.09-4.176.175 6.691-6.69-.816-.817-6.633 6.633.135-4.06-1.09-.008zM24.832 11.204L30.946 11l-.257 6.112-1.09-.019.175-4.175-6.69 6.69-.817-.816L28.9 12.16l-4.06.135-.008-1.09z",
  fill: "#333"
});
function SvgMoreViews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}
export default SvgMoreViews;